<template>
  <el-dialog :title="title" :visible.sync="visible" :before-close="closeDialog" @closed="closeDialog" width="30%" @open="addOpen" :close-on-click-modal="false">
    <el-form :model="formData" :rules="addFormRules" ref="addFormRef" label-width="80px">
      <el-form-item label="名称" prop="name">
        <el-input v-model="formData.name"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="addConfirm" :disabled="confirmDisable">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'category_group_add',
  props: [
    'visible', 'id'
  ],
  data () {
    return {
      title: '添加分类',
      confirmDisable: false,
      formData: {
        name: '',
        p_id: 0
      },
      addFormRules: {
        name: [
          { required: true, message: '名称不能为空', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    closeDialog () {
      this.$refs.addFormRef.resetFields()
      this.$emit('closeDialog')
    },
    addConfirm () {
      this.$refs.addFormRef.validate(valid => {
        if (!valid) return
        // 验证通过
        this.confirmDisable = true
        if (this.id === 0) {
          this.$emit('add', this.formData)
        } else {
          this.$emit('update', this.id, this.formData)
        }
      })
    },
    addOpen () {
      // 如果id>0,则是编辑信息
      if (this.id > 0) {
        this.title = '编辑分类'
        this.getInfo(this.id)
      }
      this.confirmDisable = false
    },
    async getInfo (id) {
      const res = await this.$http.get('/admin/article/category/info/' + id)
      if (res.code === 0) {
        this.formData = {
          name: res.data.name,
          p_id: res.data.p_id,
          post_status: res.data.post_status
        }
      }
    }
  }
}
</script>

<style>
</style>
